import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

// Shown in the "All Students" view whenever no completion filter is active,
// so a counselor looking at the default (unfiltered) list can immediately
// see how many students still haven't completed the survey, without having
// to apply a filter first.
const CompletionBanner = ({ meta, onShowNotCompleted }) => {
  if (!meta || meta.notCompletedInScope === 0) return null;

  return (
    <div className="mb-6 bg-amber-50 border border-amber-200 rounded-lg p-4 flex items-center justify-between flex-wrap gap-3">
      <div className="flex items-start">
        <FiAlertTriangle className="h-5 w-5 text-amber-600 mt-0.5 mr-3 flex-shrink-0" />
        <p className="text-sm text-amber-900">
          <span className="font-semibold">{meta.notCompletedInScope}</span> of{' '}
          <span className="font-semibold">{meta.totalInScope}</span> students{' '}
          {meta.totalInScope === meta.notCompletedInScope ? 'have' : 'still have'} not completed the survey.
        </p>
      </div>
      <button
        onClick={onShowNotCompleted}
        className="px-3 py-1.5 text-sm font-medium text-amber-800 bg-amber-100 rounded-md hover:bg-amber-200 transition-colors whitespace-nowrap"
      >
        Show only not completed
      </button>
    </div>
  );
};

export default CompletionBanner;
